import { Flex, HStack } from '@chakra-ui/react';
import { FC } from 'react';
import { AgentSearchFilter } from './AgentSearchFilter';
import { DateRangeFilter } from './DateRangeFilter';
import { OfficeFilter } from './OfficeFilter';
import { PropertyTypeFilter } from './PropertyTypeFilter';
import { SearchFilter } from './SearchFilter';
import { SideFilter } from './SideFilter';
import { StateFilter } from './StateFilter';
import { StatusFilter } from './StatusFilter';

export const OrganizationComplianceFilters: FC = () => {
  return (
    <Flex align="center" gap={4}>
      <HStack align="flex-end" spacing={4}>
        <SearchFilter />
        <AgentSearchFilter />
        <OfficeFilter />
        <SideFilter />
        <DateRangeFilter />
        <StateFilter />
        <StatusFilter />
        <PropertyTypeFilter />
      </HStack>
    </Flex>
  );
};
